import React, { useState } from 'react';
import axios from 'axios';

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!username || !password) { setErr('Username and password required'); return; }
    setLoading(true); setErr('');
    try {
      const r = await axios.post('/api/admin/login', { username, password });
      onLogin(r.data.username);
    } catch (e) {
      setErr(e.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-login-wrap">
      <div className="admin-login-card">
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 28, fontWeight: 900, color: 'var(--primary)', letterSpacing: 2, background: 'var(--bg)', display: 'inline-block', padding: '6px 12px', borderRadius: 6 }}>MCS</div>
        </div>
        <h2>Admin Login</h2>
        <div className="field-group">
          <label className="field-label">Username</label>
          <input className="field-input" value={username} onChange={e => setUsername(e.target.value)}
            placeholder="Username" autoFocus onKeyDown={e => e.key === 'Enter' && submit()} />
        </div>
        <div className="field-group">
          <label className="field-label">Password</label>
          <input className="field-input" type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Password" onKeyDown={e => e.key === 'Enter' && submit()} />
        </div>
        {err && <div className="field-error" style={{ marginBottom: 12 }}>{err}</div>}
        <button className="btn-primary" style={{ width: '100%', padding: 14 }} onClick={submit} disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </div>
    </div>
  );
}
